<template>
  <div class="division-label body-box">
    <div class="division-label-left">
      <Tree
        @changeSwitch="changeSwitch"
        :switchVal="searchParams.isDown"
        @nodeClick="nodeClick"
      ></Tree>
    </div>
    <div class="division-label-righ">
      <TabelSearch
        :searchConfig="searchConfig"
        :searchParams="searchParams"
        @resetCallBack="resetCallBack"
        @search="setSearchParams"
      ></TabelSearch>
      <Table
        :width="'100%'"
        :tableLoading="tableLoading"
        :tabelButtons="tabelButtons"
        :templateData="tableTemplateData"
        :tableConfig="tableConfig"
        :pagination="pagination"
      >
      </Table>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="title"
      :visible.sync="dialogVisible"
      width="400px"
      :before-close="handleClose"
    >
      <editForm
        ref="ruleForm"
        :formConfig="formConfig"
        :ruleForm="ruleForm"
        :rules="rules"
        :buttonConfig="buttonConfig"
      ></editForm>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="关联摄像头"
      :visible.sync="dialogVisible2"
      width="60%"
      :before-close="handleClose2"
    >
      <div class="dialog-body">
        <div class="dialog-top space-between" style="margin-bottom: 15px">
          <el-button type="primary" @click="addAssociated">新增关联</el-button>
          <div class="">
            <el-input
              v-model="tagCameraSearchParams.cameraName"
              placeholder="请输入摄像机名称"
              style="margin-right: 10px"
            ></el-input>
            <el-button type="primary" @click="relevancyCamera">查询</el-button>
            <el-button @click="resetRelevancyCamera">重置</el-button>
          </div>
        </div>
        <div class="dialog-table">
          <Table
            :width="'100%'"
            :tableLoading="tagCameraLoading"
            :tabelButtons="tagCameraButtons"
            :templateData="tagCameraData"
            :tableConfig="tagCameraConfig"
            :pagination="tagCameraPagination"
          >
          </Table>
        </div>
      </div>
      <!--			<span slot="footer" class="dialog-footer">-->
      <!--				<el-button @click="handleClose">取 消</el-button>-->
      <!--			</span>-->
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="新增关联"
      :visible.sync="dialogVisible3"
      width="70%"
      :before-close="handleClose3"
    >
      <div class="dialog-body" style="height: 400px">
        <div class="space-between" style="height: 100%">
          <div class="treeBox" style="height: 400px">
            <Tree
              @changeSwitch="changeSwitch2"
              :showSwitch="true"
              :title="'指挥中心'"
              @nodeClick="nodeClick2"
            ></Tree>
          </div>
          <div class="dialog-table" style="margin-left: 20px; flex: 1">
            <TabelSearch
              :searchConfig="getAllCameraSearchConfig"
              :searchParams="getAllCameraSearchParams"
              @resetCallBack="getAllCameraResetCallBack"
              @search="getAllCameraSetSearchParams"
            ></TabelSearch>
            <Table
              :tableLoading="getAllCameraTableLoading"
              :tabelButtons="getAllCameraTabelButtons"
              :templateData="getAllCameraTableTemplateData"
              :tableConfig="getAllCameraTableConfig"
              :pagination="getAllCameraPagination"
            >
            </Table>
          </div>
        </div>
      </div>
      <!--			<span slot="footer" class="dialog-footer">-->
      <!--				<el-button type="primary" @click="handleClose3">返 回</el-button>-->
      <!--			</span>-->
    </el-dialog>
  </div>
</template>

<script>
import Tree from "../../../../components/Tree/nodeTree";
import Table from "../../../../components/table/table";
import TabelSearch from "../../../../components/tabel-search/tabel-search";
import { vidiconApi } from "../../../../api-path/vidicon-api";
import { cameraApi } from "../../../../api-path/district-api.js";
export default {
  name: "division-label",
  //editForm
  components: {
    Table,
    TabelSearch,
    Tree,
  },
  data() {
    return {
      ruleForm: {
        areaId: "",
        areaName: "",
        id: "",
        tagName: "",
      },
      tagIds: [],
      rules: {
        tagName: [{ required: true, message: "请输入标签名称", trigger: "blur" }],
        areaName: [{ required: true, message: "请选择区域", trigger: "blur" }],
      },
      formConfig: {
        disabled: false,
        items: [
          [
            {
              valueType: "input",
              label: "标签名称",
              key: "tagName",
              prop: "tagName",
              labelWidth: "100px",
              itemWidth: "100%",
              maxlength: "50",
              placeholder: "请输入标签名称",
            },
          ],
          [
            {
              valueType: "tree-selected", // 类型
              label: "注册区域",
              key: "areaName", // 数据名称
              prop: "areaName", // 验证规则
              labelWidth: "100px", // label 宽度
              itemWidth: "100%",
              maxlength: 50,
              placeholder: "请选择区域", // 提示信息
              fn: (data) => {
                //选择的值
                this.ruleForm.areaId = data.id;
                this.ruleForm.areaName = data.name;
              },
            },
          ],
        ],
      },
      buttonConfig: {
        buttons: [
          {
            type: "save", // 保存
            loading: false,
            fn: (data) => {
              this.$http.post(vidiconApi.saveCameraTag, data).then((res) => {
                if (res.status === 200) {
                  this.$message.success(this.title + "成功");
                  this.dialogVisible = false;
                  this.startSearch();
                }
              });
            },
          },
          {
            type: "back", // 返回
            fn: () => {
              this.handleClose();
            },
          },
        ],
      },
      ruleForm2: {
        areaId: null,
        areaName: "",
        cameraName: "",
        isDown: "",
        tagId: "",
        page: 1,
        size: 15,
      },
      cameraData: [], //标签下的摄像机列表
      cameraData2: [], //未关联的摄像机列表
      title: "新增标签",
      dialogVisible: false,
      dialogVisible2: false,
      dialogVisible3: false,
      searchParams: {
        tagName: "", //标签名称
        areaId: "",
        isDown: false, //是否想下查询
        page: 1,
        size: 15,
      },
      searchConfig: {
        dataName: "searchParams",
        items: [
          {
            key: "tagName",
            valueType: "text",
            placeholder: "请输入标签名称",
          },
        ],
      },
      //表格
      tableLoading: false,
      tableTemplateData: [],
      tabelButtons: [
        {
          type: "add",
          fn: () => {
            this.ruleForm = {
              areaId: "",
              areaName: "",
              id: "",
              tagName: "",
            };
            this.dialogVisible = true;
          },
        },
        {
          type: "relevancy",
          title: "关联摄像机",
          fn: () => {
            this.tagCameraSearchParams.tagId = this.tagIds[0];
            this.dialogVisible2 = true;
            this.tagCameraSearchParams.page = this.tagCameraPagination.page = 1;
            this.relevancyCamera();
          },
        },
      ],
      tableConfig: {
        checkbox: true,
        index: true,
        checkboxFn: (data) => {
          this.tagIds = [];
          data.forEach((item) => {
            this.tagIds.push(item.id);
          });
        },
        rows: [
          {
            label: "所属区域",
            prop: "areaName",
          },
          {
            label: "标签名称",
            prop: "tagName",
          },
        ],
        rowButtons: {
          width: "300px",
          items: [
            {
              label: "编辑",
              fn: (data) => {
                this.title = "编辑摄像机标签";
                this.dialogVisible = true;
                this.ruleForm = data;
                // this.$http.get(vidiconApi.getCameraTag, {
                // 	params: {
                // 		id: data.id
                // 	}
                // }).then(res => {
                // 	if (res.status == 200) {
                // 		this.ruleForm = res.result;
                // 		this.dialogVisible = true;
                // 	}
                // })
              },
            },
            {
              label: "删除",
              type: "danger",
              fn: (data) => {
                this.$confirm("此操作将删除该摄像机标签, 是否继续?", "提示", {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning",
                })
                  .then(() => {
                    this.$http
                      .delete(vidiconApi.delCameraTag, { params: { id: data.id } })
                      .then((res) => {
                        if (res.status == 200) {
                          this.$message.success("删除成功");
                          this.startSearch();
                        }
                      });
                  })
                  .catch(() => {});
              },
            },
          ],
        },
      },
      pagination: {
        show: true,
        total: 0,
        page: 1,
        size: 15,
        sizeChange: this.sizeChange,
        pageChange: this.pageChange,
      }, // 分页
      //标签下面的
      tagCameraSearchParams: {
        tagId: "",
        cameraName: "",
        page: 1,
        size: 15,
      },
      tagCameraLoading: false,
      tagCameraButtons: [],
      tagCameraData: [],
      tagCameraConfig: {
        checkbox: false,
        index: true,

        rows: [
          {
            label: "摄像机名称",
            prop: "cameraName",
          },
          {
            label: "区域",
            prop: "arearName",
          },
          {
            label: "地址",
            prop: "address",
          },
        ],
        rowButtons: {
          width: "100px",
          items: [
            {
              label: "取消关联",
              type: "danger",
              fn: (data) => {
                this.$confirm("此操作将取消关联该摄像仪, 是否继续?", "提示", {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning",
                })
                  .then(() => {
                    this.notCancel(data.id);
                  })
                  .catch(() => {});
              },
            },
          ],
        },
      },
      tagCameraPagination: {
        show: true,
        total: 0,
        page: 1,
        size: 15,
        sizeChange: this.tagCameraSizeChange,
        pageChange: this.tagCameraPageChange,
      },
      //获取所有摄像头
      getAllCameraTableLoading: false,
      getAllCameraSearchConfig: {
        dataName: "getAllCameraSearchParams",
        items: [
          {
            key: "search",
            valueType: "text",
            placeholder: "请输入关键词",
          },
        ],
      },
      getAllCameraSearchParams: {
        areaId: "0",
        search: "", //关键词
        isDown: false,
        page: 1,
        size: 5,
      },
      getAllCameraTableTemplateData: [],
      getAllCameraTabelButtons: [
        {
          type: "edit", //
          title: "新增关联",
          fn: (data) => {
            let cameraIds = [];
            data.forEach((item) => {
              cameraIds.push(item.id);
            });
            this.$http
              .post(vidiconApi.bindingTag, {
                cameraIds: cameraIds,
                tagId: this.tagIds[0],
              })
              .then((res) => {
                if (res.status == 200) {
                  this.dialogVisible3 = false;
                  this.$message.success("新增关联成功");
                  this.relevancyCamera();
                }
              });
          },
        },
      ],
      getAllCameraTableConfig: {
        checkbox: true,
        checkboxFn: (data) => {
          console.log(data);
        },
        rows: [
          {
            label: "名称",
            prop: "name",
          },
          {
            label: "所属区域",
            prop: "areaName",
          },
          {
            label: "地址",
            prop: "address",
          },
        ],
        rowButtons: {},
      },
      getAllCameraPagination: {
        show: true,
        total: 0,
        page: 1,
        size: 5,
        pageSizes: [5],
        sizeChange: this.getAllCameraSizeChange,
        pageChange: this.getAllCameraPageChange,
      }, // 分页
      searchParamsAreaId: "",
    };
  },
  created() {},
  methods: {
    changeSwitch(e) {
      this.searchParams.isDown = e;
      this.isDown = e;
      this.startSearch();
    },
    nodeClick(node) {
      this.searchParams.areaId = node.id;
      this.ruleForm.areaId = node.id;
      this.ruleForm.areaName = node.id ? node.name : "";
      this.areaId = node.id;
      this.areaName = node.id ? node.name : "";
      this.searchParams.page = this.pagination.page = 1;
      this.startSearch();
    },
    startSearch() {
      this.$http
        .get(vidiconApi.CameraTagList, {
          params: this.searchParams,
        })
        .then((res) => {
          if (res.status == 200) {
            this.tableTemplateData = res.result.pageList;
            this.pagination.total = res.result.total;
          }
        });
    },
    setSearchParams(value) {
      if (value) {
        this.pagination.page = value.page;
      }
      this.startSearch();
    },
    resetCallBack() {
      this.searchParams.areaId = this.areaId;
      this.searchParams.areaName = this.areaName;
      this.searchParams.isDown = this.isDown;
      this.searchParams.page = this.pagination.page = 1;
      this.startSearch();
    },
    handleClose() {
      this.dialogVisible = false;
    },
    handleClose2() {
      this.dialogVisible2 = false;
    },
    // 每页显示条数
    sizeChange(size) {
      this.pagination.size = size;
      this.searchParams.size = size;
      this.startSearch();
    },
    // 当前页
    pageChange(page) {
      this.pagination.page = page;
      this.searchParams.page = page;
      this.startSearch();
    },
    //获取关联摄像头
    getCameraList() {},
    //-----------start获取所有摄像头
    getAllCameraSetSearchParams() {
      this.$http
        .get(cameraApi.queryListByPage, {
          params: this.getAllCameraSearchParams,
        })
        .then((res) => {
          if (res.status === 200) {
            this.getAllCameraTableTemplateData = res.result.pageList;
            this.getAllCameraPagination.total = res.result.total;
          }
        });
    },
    changeSwitch2(e) {
      this.getAllCameraSearchParams.isDown = e;
      this.isDown2 = e;
      this.getAllCameraSetSearchParams();
    },
    nodeClick2(node) {
      this.getAllCameraSearchParams.areaId = node.id;
      this.searchParamsAreaId = node.id;
      this.getAllCameraPagination.page = 1;
      this.getAllCameraSetSearchParams();
    },
    getAllCameraResetCallBack() {
      this.getAllCameraSearchParams = {
        areaId: this.searchParamsAreaId,
        search: "", //关键词
        isDown: this.getAllCameraSearchParams.isDown,
        page: 1,
        size: 5,
      };
      this.getAllCameraPagination.page = 1;
      this.getAllCameraSetSearchParams();
    },
    // 每页显示条数
    getAllCameraSizeChange(size) {
      this.getAllCameraPagination.size = this.getAllCameraSearchParams.size = size;
      this.getAllCameraSetSearchParams();
    },
    // 当前页
    getAllCameraPageChange(page) {
      this.getAllCameraPagination.page = this.getAllCameraSearchParams.page = page;
      this.getAllCameraSetSearchParams();
    },
    tagCameraSizeChange(size) {
      this.tagCameraPagination.size = this.tagCameraSearchParams.size = size;
      this.relevancyCamera();
    },
    tagCameraPageChange(page) {
      this.tagCameraPagination.page = this.tagCameraSearchParams.page = page;
      this.relevancyCamera();
    },
    handleClose3() {
      this.dialogVisible3 = false;
    },
    //--------------end
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$http.get(vidiconApi.saveCameraTag, this.ruleForm).then((res) => {
            if (res.status == 200) {
              this.$message.success(this.title + "成功");
              this.startSearch();
            }
          });
          this.dialogVisible = false;
        } else {
          return false;
        }
      });
    },
    associated(data, isTrue) {
      //取消关联
      if (isTrue) {
        //关联
        let params = {
          cameraIds: [data.id],
          tagId: this.tagId,
        };
        this.$http.post(vidiconApi.bindingTag, params).then((res) => {
          if (res.status == 200) {
            this.$message.success("关联成功了");
          }
        });
      } else {
        //取消关联
        let params = {
          ids: [data.id],
        };
        this.$http.post(vidiconApi.notCancel, params).then((res) => {
          if (res.status == 200) {
            this.$message.success("取消关联成功了");
          }
        });
      }
    },
    addAssociated() {
      //新增关联
      this.dialogVisible3 = true;
      // this.getAllCameraSetSearchParams();
    },
    relevancyCamera() {
      this.$http
        .get(vidiconApi.correspondCameraList, { params: this.tagCameraSearchParams })
        .then((res) => {
          if (res.status == 200) {
            this.tagCameraData = res.result.pageList;
            this.tagCameraPagination.total = res.result.total;
          }
        });
    },
    resetRelevancyCamera() {
      this.tagCameraSearchParams.cameraName = "";
      this.tagCameraSearchParams.page = this.tagCameraPagination.page = 1;
      this.tagCameraSearchParams.size = this.tagCameraPagination.size = 15;
      this.relevancyCamera();
    },
    notCancel(id) {
      let params = { ids: [id] };
      this.$http.post(vidiconApi.notCancel, params).then((res) => {
        if (res.status == 200) {
          this.$message.success("取消关联成功了");
          this.relevancyCamera();
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
.division-label {
  margin-left: 10px;
  box-sizing: border-box;
  height: 100%;
  padding: 10px;
  border-radius: 10px;
  background: #fff;
  display: flex;
  .division-label-left {
    margin-right: 10px;
    border-right: 1px solid #c1c1c1;
  }

  .division-label-righ {
	flex: 1;
	display: flex;
	flex-direction: column;
  }
}
</style>
